<template>
  <div
    class="slide gallery"
    :style="
      slide.backgroundColor
        ? `background-color: ${slide.backgroundColor};`
        : 'transparent;'
    "
  >
    <Loading v-if="isLoading"></Loading>
    <div
      class="bg-full"
      v-if="slide.photo"
      :style="`background-image: url(${slide.photo})`"
    ></div>
    <vue-justified-layout
      :items="items"
      v-slot="{ item, style, index }"
      ref="grid"
      :options="{
        targetRowHeight: rowHeight,
        showWidows: true,
        boxSpacing: 1,
        containerPadding: 10,
        forceAspectRatio: false,
      }"
      class="center-img"
    >
      <img :src="item.thumb" @click="openLightbox(index)" @load="onImgLoad" />
    </vue-justified-layout>

    <app-footer
      :footer="slide.footnote"
      :details="slide.details"
      position=""
    ></app-footer>
  </div>
</template>

<script>
import AppFooter from "./Footer";
import Loading from "./Loading.vue";
import { VueJustifiedLayout } from "vue-justified-layout";
import loaderMixin from "../mixins/loader";
// import {LightGallery} from 'vue-light-gallery';

export default {
  props: ["slide", "window"],
  data() {
    return {
      rowHeight: null,
      index: null,
      numLoadedImages: 0,
    };
  },
  components: { AppFooter, VueJustifiedLayout, Loading },
  mixins: [loaderMixin],
  methods: {
    openLightbox(index) {
      this.$emit("openLightbox", {
        photos: this.slide.gallery,
        index: index,
      });
    },
    onImgLoad() {
      this.numLoadedImages++;
      if (this.numLoadedImages >= this.slide.gallery.length) {
        this.isLoading = false;
      }
    },
  },
  computed: {
    items() {
      let numPhotos = this.slide.gallery.length;
      if (numPhotos == 2 && this.window.width > 480) {
        return this.slide.gallery.map((item) => {
          item.width = this.window.width / 2;
          item.height = this.window.height - 20;
          return item;
        });
      } else if (numPhotos == 2 && this.window.width <= 480) {
        return this.slide.gallery.map((item) => {
          item.width = this.window.width - 20;
          item.height = this.window.height / 2 - 20;
          return item;
        });
      } else {
        return this.slide.gallery
      }
    },
  },
  mounted() {
    let numPhotos = this.slide.gallery.length;
    this.rowHeight = this.window.height;

    if (numPhotos == 2) {
      this.rowHeight = this.window.height;
    } else if (numPhotos <= 3) {
      this.rowHeight = Math.round(this.window.height / 2) + 300;
    } else if (numPhotos <= 5) {
      this.rowHeight = Math.round(this.window.height / 3);
      if (this.window.width > 1492) {
        this.rowHeight += 220;
      }
    } else {
      this.rowHeight = Math.round(this.window.height / 5) + 100;
    }

    // setTimeout(() => {
    //   this.rowHeight = 1415;
    // }, 3000);

    // let grid = this.$refs.grid;
    // console.log(grid)
    // let resizeInterval = setInterval(() => {
    //   this.rowHeight = this.rowHeight - 10
    //   console.log('targetRowHeight', this.rowHeight)
    //   console.log('grid height', grid.style.height)
    //   if (parseInt(grid.style.height) < parseInt(this.window.height)) {
    //     clearInterval(resizeInterval)
    //     this.$root.$emit('rebuild')
    //   }
    // }, 1)

    console.log("numPhotos", numPhotos);
    console.log("rowHeight", this.rowHeight);
  },
};
</script>

<style scoped>
img {
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
}
.bg-full {
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.5;
  filter: blur(35px);
}
</style>
